
import { Component, Prop, Vue } from "vue-property-decorator";
import AppButton from "./AppButton.vue";

@Component({
  components: { AppButton },
})
export default class NotificationPermissionModal extends Vue {
  @Prop({ type: Boolean, default: false }) readonly value!: boolean;

  handleOk(): void {
    this.$emit("ok");
  }
}
